<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/DHT3L/DHT3L.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">3DHT215 混动专用变速器</div>
                <div class="detail-banner-desc transmission">
                    单电机纵置功率分流3速混动专用变速器
                    <div class="detail-desc">
                        <div>
                            具备功率分流、直驱、增程、混动、EV等多种模式，高效功率分流模块确保发动机始终运行在最佳效率区间；<br />
                        </div>
                        <div>
                            超大速比20，4L模式下可实现轮端扭矩超8000N·m；<br />
                        </div>
                        <div>
                            馈电下仍能保持持续的动力输出；<br />
                        </div>
                        <div>
                            电机采用水冷油冷复合结构和绕组 Hairpin 结构，提升高效率区间的占比；<br />
                        </div>
                        <div>
                            集成式电控换挡系统，响应迅速，换挡丝滑；<br />
                        </div>
                        <div>
                            配置智能润滑系统，按需分配流量，降低搅油损失。<br />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="one-titile">
                    核心配置
                </div>

                <div class="spec-row">  
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数：驱动电机
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">215kW</div>
                                    <div class="k">峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">400N·m</div>
                                    <div class="k">峰值输出扭矩</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">7000rpm</div>
                                    <div class="k">最高转速</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3+R</div>
                                    <div class="k">挡位数量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">水冷+油冷</div>
                                    <div class="k">电机冷却方式</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/DHT3L/DHT3L-2.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '3DHT215 混动专用变速器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/DHT3L.html'
};

import { createApp } from 'vue';
import App from './DHT3L.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./DHT3L.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
